import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import SaleOrderNotesService from "../../Controller/SaleOrderNotesController";
import CreateSaleOrderNotes from "./CreateSaleOrderNotes";
import HelpSite from "../../../Common/HelpLink";
import SaleOrderService from "../../Controller/SaleOrderController";
function SaleOrderNotesPage({ SaleOrderID }) {
    const navigate = useNavigate();
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    SaleOrderID = localStorage.getItem('SaleOrderID');


    const [SaleOrdeNotesList, setSaleOrderNotes] = useState([]);

    const [modalInstance, setModalInstance] = useState(null);
    const [currentSaleOrderNotes, setCurrentSaleOrderNotes] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isClosed, SetIsClosed] = useState("0");
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };
    const fetchSaleOrderNotes = async () => {
        try {
            const data = await SaleOrderNotesService.GetAllSaleOrderNotes(redirectCallback, SaleOrderID);
            setSaleOrderNotes(data);
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        }
    };
    const fetchSaleOrderDetail = async () => {
        try {
            const redirectCallback = () => navigate('/');
            if (SaleOrderID > 0) {
                const saleOrderDetail = await SaleOrderService.GetSaleOrderByID(redirectCallback, SaleOrderID);
                const saleOrder = saleOrderDetail[0];
                if (saleOrder.bit_DropShipment > 0 || saleOrder.bit_DropShipmentc > 0) {
                    SetIsClosed("1");
                }

            }
        } catch (error) {
            console.error('Error fetching agreement details:', error);
        }
    };
    useEffect(() => {
        SetIsClosed("0");
        fetchSaleOrderDetail();
        fetchSaleOrderNotes();
    }, [SaleOrderID]);

    const handleCreateSaleOrderNotesClick = () => {
        setCurrentSaleOrderNotes(null);
        fetchSaleOrderNotes();
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleEditClick = (history) => {
        setCurrentSaleOrderNotes(history);
        fetchSaleOrderNotes();
        setIsModalOpen(true);
    };
    const handleSuccess = () => {
        fetchSaleOrderNotes();// Refresh the list after submission
        handleCloseModal();   // Close the modal
    };

    const handleDeleteClick = async (ID, redirectCallback) => {
        const confirmed = window.confirm("Are you sure you want to delete this contact?");
        if (confirmed) {
            try {
                await SaleOrderNotesService.DeleteSaleOrderNotes(ID, redirectCallback);
                fetchSaleOrderNotes(); // Refresh the list after deletion
            } catch (error) {
                console.error('Error deleting Contact:', error);
            }
        }
    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-3">
                    <button className={`btn btn-primary btn-sm ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} onClick={handleCreateSaleOrderNotesClick} disabled={isClosed === '1' || isClosed === 1}>
                        <i className="icofont-plus" aria-hidden="true"> Add New</i>
                    </button>
                </div>
                <div className="col-sm-9" style={{ "textAlign": "right" }}>

                </div>
            </div>
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-12">
                    <div className="">
                        <table className="table m-0 table-hover">
                            <thead>
                                <tr>
                                    <th>Created</th>
                                    <th>Created By</th>
                                    <th>Description</th>

                                    <th style={{ "textAlign": "right" }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {SaleOrdeNotesList.map((notes) => (
                                    <tr key={notes.PK_SalesOrderNotes_ID} onClick={() => handleEditClick(notes)} disabled={isClosed === '1' || isClosed === 1 || localStorage.getItem('LicenseExpired') == "1"}>
                                        <td>{formatDate(notes.dt_Created)}</td>
                                        <td>{notes.FK_User_ID}</td>

                                        <td dangerouslySetInnerHTML={{ __html: notes.vc_Description }}></td>


                                        <td style={{ "textAlign": "right" }}>

                                            <button style={{ "background": "none", "border": "none" }} className="text-danger" onClick={() => handleDeleteClick(notes.PK_SalesOrderNotes_ID)} disabled={isClosed === '1' || isClosed === 1 || localStorage.getItem('LicenseExpired') == "1"}>
                                                <i className="icofont-ui-delete" aria-hidden="true"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            {isModalOpen && (
                <CreateSaleOrderNotes
                    modalInstance={modalInstance}
                    currentSaleOrderNotes={currentSaleOrderNotes}
                    onClose={handleCloseModal}
                    onSuccess={handleSuccess}

                    SaleOrderID={SaleOrderID}


                />
            )}
        </div>
    );
}

export default SaleOrderNotesPage;
